export enum SharePermission {
  EDITOR = 'editor',
  VIEWER = 'viewer',
}

export enum ShareReason {
  DIRECT = 'direct',
  INHERITED = 'inherited',
}

export type HideBlankStyleGetDto = {
  enabled: boolean;
  type: ShareReason;
};

export enum ShareResource {
  COLLECTION = 'collection',
  PRODUCT = 'product',
}

export type Share = {
  permission: SharePermission;
  type: ShareReason;
  userId: string;
};

/**
 * User license.
 */
export enum UserPermission {
  OWNER = 'owner',
  EDITOR = 'editor',
  VIEWER = 'viewer',
}

export const UserPermissionLevel = {
  [UserPermission.OWNER]: 2,
  [UserPermission.EDITOR]: 1,
  [UserPermission.VIEWER]: 0,
};

const ORG_SHARE_PREFIX = 'org:';
const ORG_SHARE_SUFFIX = '#member';

/**
 * True if userId represents an org share (format org:{orgId}#member).
 */
export const isOrgShare = (userId: string): boolean =>
  userId.startsWith(ORG_SHARE_PREFIX) && userId.includes(ORG_SHARE_SUFFIX);

/**
 * Parse orgId from a share userId of the form org:{orgId}#member.
 * Returns null if the format does not match.
 */
export const getOrgIdFromShareUserId = (userId: string): string | null => {
  if (!isOrgShare(userId)) return null;
  const start = ORG_SHARE_PREFIX.length;
  const end = userId.indexOf(ORG_SHARE_SUFFIX);
  return end > start ? userId.slice(start, end) : null;
};
